<template>
    <div>
        <div class="headView">
            <div class="headView_top">
                <p class="applyTitle">项目名称：{{project.project_name}}</p>
                <!-- <button type="button" @click="showScore">初审打分</button> -->
            </div>
            <div class="headClass">
                <p>项目类型：{{project.project_type_name}}</p>
                <p>申请时间：{{project.apply_start}}-{{project.apply_end}}</p>
                <p>审核时间：{{project.app_start}}-{{project.app_end}}</p>
            </div>
        </div>
        <!-- 申报审核通用封装组件 -->
        <div class="content_view">
            <div class="contentLeft">
                <p v-for="(item,index) in navList" v-show="navList[index]" :key="index" @click="changeTab(index)"
                   :class="navIndex === index?'tabActive':''">
                    {{item}}
                </p>
            </div>
            <div class="contentRight">
                <div v-show="navIndex == 0">
                    <p class="view_head">申报须知</p>
                    <!-- pdf -->
                    <pdfVue v-if="require_pdf_url" :pdf_url="require_pdf_url"></pdfVue>
                </div>
                <div v-show="navIndex == 1">
                    <p class="view_head">评选办法</p>
                    <!-- pdf -->
                    <pdfVue v-if="selection_pdf_url" :pdf_url="selection_pdf_url"></pdfVue>
                </div>
                <div v-show="navIndex == 2">
                    <p class="view_head">
                        基本信息
                    </p>
                    <div class="inputList" >
                        <!-- 非优质安装工程基本信息 -->
                        <labelText v-for="(item,index) in basicInfo" :key="index" :spanTitle="item.title"
                                   :spanWidth="spanWidth" componentWidth="520px" :pContent="item.data">
                        </labelText>
                    </div>

                </div>

                <div class="" v-show="navIndex == 3">
                    <div>
                        <p class="view_head">资质</p>
                        <div style="display: flex;flex-wrap: wrap;margin-top: 20px;" v-for="(item,index) in award">

                            <div class="inputList">
                                <labelText :spanTitle= " '资质类别' + (index+1)" v-if="item.qualification_category" :spanWidth="spanWidth"
                                           componentWidth="1060px" :pContent="item.qualification_category">
                                </labelText>
                                <labelText spanTitle="等级" :spanWidth="spanWidth" componentWidth="520px"
                                           :pContent="item.qualification_level">
                                </labelText>
                                <labelText spanTitle="证书编号" :spanWidth="spanWidth" componentWidth="520px"
                                           :pContent="item.certificate_no">
                                </labelText>
                                <labelText spanTitle="有效期" :spanWidth="spanWidth" componentWidth="520px"
                                           :pContent="item.effective_time">
                                </labelText>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="uploadContent" v-show="navIndex == 4">
                    <p class="view_head">评定表</p>

                    <div style="">
                        <table class="gridtable">
                            <tbody>
                                <tr>
                                    <th colspan="2">项目</th>
                                    <th>自评分</th>
                                </tr>

                                <tr>
                                    <td colspan="2">基本素质(30分)</td>
                                    <td><el-input v-model="pdbForm.basic_quality" type="number" max="30" readonly></el-input></td>
                                </tr>

                                <tr>
                                    <td rowspan="5">经济指标(30分)</td>
                                    <td>企业净资产(6分)</td>
                                    <td><el-input v-model="pdbForm.net_assets" type="number" readonly></el-input></td>
                                </tr>

                                <tr>
                                    <td>工程结算收入(6分)</td>
                                    <td><el-input v-model="pdbForm.project_settle_income" type="number" readonly></el-input></td>
                                </tr>

                                <tr>
                                    <td>净资产增长率(6分)</td>
                                    <td><el-input v-model="pdbForm.growth_rate" type="number" readonly></el-input></td>
                                </tr>

                                <tr>
                                    <td>资产负债率(6分)</td>
                                    <td><el-input v-model="pdbForm.liability_ratio" type="number" readonly></el-input></td>
                                </tr>

                                <tr>
                                    <td>产值利润率(6分)</td>
                                    <td><el-input v-model="pdbForm.profit_rate" type="number" readonly></el-input></td>
                                </tr>

                                <tr>
                                    <td colspan="2">企业管理(40分)</td>
                                    <td><el-input v-model="pdbForm.enp_management" type="number" readonly></el-input></td>
                                </tr>

                                <tr>
                                    <td rowspan="2">市场信用（20）</td>
                                    <td>优良信息</td>
                                    <td><el-input v-model="pdbForm.good_msg" type="number" readonly></el-input></td>
                                </tr>

                                <tr>
                                    <td>-不良信息(负分)</td>
                                    <td><el-input v-model="pdbForm.bad_msg" type="number" readonly></el-input></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- 优秀项目经理显示资料上传 -->
                <div class="newTab" v-show="navIndex == 5">
                    <!--<div class="uploadHead" @click="upShow('muban')">
                        <img :src="numbanDoload" style="width: 20px;height: 20px;">
                        <p>模板下载</p>
                    </div>-->
                    <p class="view_head">资料上传</p>
                    <div class="uploadList" v-for="(item,index) in uploadData.title" :key="index">
                        <div class="uploadList_head">
                            <p>{{item}}</p>

                            <!-- 开启上传 -->
                            <div class="head_list" v-if="changeInput">
                                <img v-if="index === 0" :src="require('../../assets/img/main/download.png')"
                                     style="width: 20px;height: 20px;">
                                <p v-if="index === 0" @click="downLoadFile" style="margin-right: 20px;">点击下载</p>
                                <img :src="uploadImg" style="width: 20px;height: 20px;">
                                <p @click="upShow('upload',index)">点击上传</p>
                            </div>

                        </div>
                        <div class="uploadList_mid">
                            <p>{{uploadData.tips[index]}}</p>
                        </div>
                        <div class="uploadList_bot">
                            <div class="inner_upload" v-for="(item,key) in uploadList[index]" :key="key"
                                 @click="navTo(item)">
                                <p>{{item.data_name?item.data_name:item.name}}</p>
                                <img v-if="changeInput" src="../../assets/img/login/cuowu.png"
                                     @click.stop="deleteUpload(key,index)">
                            </div>
                            <!-- <p v-for="(item,key) in uploadList[index]" :key="key" @click="navTo(item)">
                                {{item.data_name?item.data_name:item.name}}
                            </p> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!--  <div class="uploadBtn" v-if="navIndex == 2 && changeInput">
              <el-button type="primary" @click="setBasicInfo">保存</el-button>
          </div>

          <div class="uploadBtn" v-if="navIndex == 4 && changeInput" style="display: flex;flex-flow: column;">
              <div class="content_btn">
                  <p>资料上传后请点击保存</p>
              </div>
              <el-button type="primary" @click="setUploadFile">保存</el-button>
          </div>-->

        <!-- 弹窗 -->
        <addDialog ref="download" @submitSuccess="submitSuccess"></addDialog>
        <!-- 弹窗 -->
        <feedDetail ref="feedDetail"></feedDetail>
        <!-- <scoreDialog ref="scoredialog" @chooseDetail="chooseDetail"></scoreDialog> -->
    </div>
</template>

<script>
    import {
        getApplicationDetail
    } from '../../api/moudles/management.js'
    import {
        getDataItem,
        sureUpdate,
        setBasicProgram,
        getUploadFile
    } from '../../api/moudles/manager.js'
    import {
        API_DOMAIN
    } from '../../api/api.js'
    import pdfVue from './components/pdfVue.vue'
    import labelInput from '../../components/table/labelInput.vue'
    import labelText from '../../components/table/labelText.vue'
    import scoreDialog from './components/scoreDialog.vue'
    import addDialog from './components/addDialog.vue'
    import feedDetail from './components/feedDetail.vue'
    import normalTable from '../../components/table/normalTable.vue'
    import normalSelect from '../../components/table/normalSelect.vue'
    import upload_img from '../../assets/img/main/upload.png'
    import muban_doload from '../../assets/img/main/muban.png'
    export default {
        data() {
            return {
                project_code: '',
                project_app_num: '',
                // 上传文件列表
                clickIndex: 0,
                uploadImg: upload_img,
                numbanDoload: muban_doload,
                // 参建单位
                addList: [],
                // 参建方式
                installList: [
                    [{
                        name: '建设单位',
                        code: '建设单位'
                    }, {
                        name: '设计单位',
                        code: '设计单位'
                    }, {
                        name: '监理单位',
                        code: '监理单位'
                    }, {
                        name: '其他施工单位',
                        code: '其他施工单位'
                    }]
                ],
                changeInput: false,
                allList: '',
                dataList: '',
                oldAddList: [],
                // 修改意见
                tabList: ['反馈时间', '意见详情', '修改状态', '修改时间', '动作'],
                tableList: [],
                codeList: [],


                id: '',
                project: '',
                award: '',
                navIndex: 0,
                spanWidth: '180px',
                navList: [
                    "申报须知",
                    "评选办法",
                    "基本信息",
                    "资质",
                    "评定表",
                    "资料上传",
                ],
                // 基础信息表单加内容
                basicInfo: [],
                formName: {
                    name: "姓名",
                    id_card: "身份证号码",
                    birth_date: "出生年月",
                    education: "学历",
                    join_work_time: "参加工作时间",
                    title: "职称",
                    major: "建造师专业",
                    level: "建造师等级",
                    req_number: "注册编号",
                    post: "获奖工程所从事职务",
                    tellphone: '本人联系电话',
                    department: "单位主管部门",
                    enp_contacts: "单位联系人",
                    enp_contacts_phone: "联系电话",
                    continue_edu_year: "最近一次继续教育年度",
                },
                // 优秀项目成果
                newFormName: {
                    company_name: '单位名称',
                    engineering: '工程名称',
                    project_name: '项目部名称',
                    contacts: '联系人',
                    contacts_phone: '联系电话',
                    achievement_name: '论文题目',
                    headcount: '编制人数',

                    author: '编制人姓名',
                },
                // 优质安装工程
                newFormNameThree: {
                    company_name: '单位名称',
                    contact_name: '联系人',
                    dep: '所在部门',
                    cellphone: '手机号',
                    // phone: '固定电话',
                    project_name: '工程名称',
                    declared_project: '申报工程内容',
                    construc_enp: '建设单位',
                    use_enp: '使用单位',
                    design_enp: '设计单位',
                    supervise_enp: '监理单位',
                    // participating_units:'',
                },
                // 先进企业
                newFormNameFour: {
                    company_name: '单位名称',
                    contacts: '联系人',
                    contacts_phone: '联系人电话',
                    output_value: '产值(万元)',
                    contract_amount: '合同额(万元)',
                    liability_ratio: '资产负债率(%)',
                    profit_rate: '利润率(%)',
                    growth_rate: '资产增长率(%)',
                },

                // 诚信企业
                newFormNameEight: {
                    company_name: '单位名称',
                    contacts_name: '申报联系人',
                    contacts_post: '职务',
                    contacts_phone: '电话',
                    cellphone: '手机',

                    liability_ratio: '资产负债率(%)',
                    profit_rate: '利润率(%)',
                    growth_rate: '资产增长率(%)',
                },

                // 质量小组
                newFormNameSix: {
                    declaration_unit: '申报单位',
                    unit_address: '单位地址',
                    group_name: '小组名称',
                    topic_name: '课题名称',
                    course_type_name: '课程类型',
                    contacts_name: '单位联系人',
                    contacts_cellphone: '联系人手机',
                    publisher: '发布人姓名',
                    publisher_phone: '发布人手机号',
                    post: '获奖工程所从事职务',
                    tellphone: '本人联系电话',
                    introduction: '小组简介',
                },
                // BIM申报
                newFormNameSeven: {
                    declarant_name: '申报人姓名',
                    declarant_post: '申报人职位',
                    declarant_phone: '申报人电话',
                    achievement_name: '成果名称',
                    achievement_group: '成果分组',
                    contacts_name: '联系人姓名',
                    contacts_phone: '联系人电话',
                    contacts_address: '联系地址',
                    // declarant_units: '申报单位',
                    leading_member: '团队成员',
                },
                // 获奖信息
                awardName: {
                    0: '质量获奖情况',
                    1: '安全文明情况'
                },
                // 优秀建造师
                awardNameOne: {
                    0: '质量获奖情况（必填）',
                    1: '安全文明情况、科技示范情况',
                    2: '省级地方、行业标准',
                    3: '科技奖、科技成果鉴定'
                },
                // 先进企业
                awardNameTwo: {
                    0: '质量获奖情况',
                    1: '',
                    2: '',
                    3: '安全文明情况',
                    4: '',
                    5: '',
                    6: '科技奖、科技成功鉴定、科技示范区',
                    7: "",
                    8: "",
                    9: "信用建设奖",
                    10: "",
                    11: ''
                },

                // 申报须知
                require_pdf_url: '',
                // 评选办法
                selection_pdf_url: '',

                // 资料上传内容
                uploadData: '',
                // 意见反馈原始数据
                originList: [],
                // 上传文件列表
                uploadList: [],
                // 模板下载
                modelList: [],

                pdbForm:{
                    basic_quality:'',
                    net_assets:'',
                    project_settle_income:'',
                    growth_rate:'',
                    liability_ratio:'',
                    profit_rate:'',
                    good_msg:'',
                    bad_msg:'',
                    enp_management:'',
                    project_app_num:'',

                },
                // 基本信息表单
                levelOne: {
                    company_name: '',
                    contact_name: '',
                    dep: '',
                    cellphone: '',
                    phone: '',
                    project_name: '',
                    declared_project: '',
                    construc_enp: '',
                    use_enp: '',
                    design_enp: '',
                    supervise_enp: '',
                },
            }
        },
        components: {
            labelInput,
            scoreDialog,
            labelText,
            pdfVue,
            addDialog,
            feedDetail,
            normalTable,
            normalSelect
        },
        created() {
            if (!this.$route.params.id) {
                this.$router.go(-1)
                return
            }
            this.id = this.$route.params.id
            this.getApplicationDetail()
        },
        methods: {
            // 下载pdf模板
            downLoadFile() {
                if (!this.project_app_num) {
                    this.$message.error('请先提交基本信息')
                    return
                }
                const url =
                    `${API_DOMAIN}/proapi/down/download-basic-msg?type=${this.project.project_type}&project_app_num=${this.project_app_num}&project_name=${this.project.project_name}`
                window.open(url)
            },
            // 保存的图片删除
            deleteUpload(key, index) {
                this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.uploadList[index].splice(key, 1)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            // 保存基本信息
            async setBasicInfo() {
                // 基本信息申报
                const params = {
                    ...this.levelOne
                }
                // 验证各个工程的表单
                if (this.requireSubmit(params, this.formName)) {
                    return
                }
                // 优质安装工程
                let newAddList = [...this.addList, ...this.oldAddList]
                for (let item in newAddList) {
                    if (!newAddList[item].name || !newAddList[item].type) {
                        this.$message.error('参建单位未填写完整')
                        return
                    }
                }
                params.participating_units = JSON.stringify(newAddList)
                params.project_app_num = this.project_app_num
                await setBasicProgram({
                    data: params,
                    success: res => {
                        console.log(res)
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                        } else {
                            this.$message.error(res.msg)
                        }
                    }
                })

            },
            // 上传文件附件保存
            async setUploadFile() {
                let newArray = this.uploadList.filter(function(s) {
                    return s && s.length
                });
                if (!newArray.length) {
                    this.$message.error('请先上传文件')
                    return
                }
                if (newArray.length < 2) {
                    this.$message.error('至少上传两条')
                    return
                }
                let dataJson = []
                this.uploadList.forEach((items, key) => {
                    items.forEach((item, index) => {
                        let data = {}
                        data['data_name'] = item.name ? item.name : item.data_name
                        data['type'] = key + 1
                        data['stored_path'] = item.url ? item.url : item.stored_path
                        dataJson.push(data)
                    })
                })
                const params = {
                    dataJson: dataJson,
                    project_app_num: this.project_app_num
                }
                await getUploadFile({
                    data: params,
                    success: res => {
                        console.log(res)
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                        } else {
                            this.$message.error(res.msg)
                        }
                    }
                })
            },
            // 获取必填警示
            requireSubmit(params, nameList) {
                //如果数据是对象形式
                let upString = []
                Object.keys(params).forEach((item, index) => {
                    if (params[item] == '' || params[item] == undefined || params[item] == null) {
                        if (nameList[item]) {
                            upString.push(item)
                        }
                    }
                })
                if (!upString.length) {
                    return false
                } else {
                    this.$message.error(`${nameList[upString[0]]}未填写`)
                    return true
                }
                // 如果数据是数组形式
            },
            // 新增行
            addInstall() {
                this.addList.push({})
            },
            // 删除行
            deleteList(index, type) {
                const number = this.addList.length + this.oldAddList.length
                if (number === 1) {
                    this.$message.error(`至少填写一条参建信息`)
                    return
                }
                if (type === '1') {
                    // 例旧信息
                    this.oldAddList.splice(index, 1)
                } else {
                    this.addList.splice(index, 1)
                }

            },

            typeThreeInput(e, type, index) {
                if (type == '1') {
                    this.addList[index].type = e
                } else {
                    this.addList[index].name = e
                }
            },
            labelInput(e, name) {
                this.levelOne[name] = e
            },
            // 接受子组件事件
            reciveClick(e) {
                const {
                    list,
                    key
                } = e
                if (list === '修改') {
                    this.changeInput = true
                    this.$message({
                        message: '现在可以重新修改',
                        type: 'success'
                    });
                    this.$nextTick(() => {
                        this.dataList = JSON.parse(JSON.stringify(this.allList))
                    })
                    setTimeout(() => {
                        this.navIndex = 2
                    }, 1000)
                } else if (list === '我已修改') {
                    this.$confirm('确认提交修改', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        // 我已修改
                        sureUpdate({
                            data: {
                                id: this.codeList[key]
                            },
                            success: res => {
                                if (res.code === 200) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success'
                                    });
                                    this.getApplicationDetail()
                                    this.changeInput = false
                                } else {
                                    this.$message.error(res.msg)
                                }
                            }
                        })
                    }).catch(() => {});
                } else {
                    //查看详情
                    this.$refs.feedDetail.showDetail(this.originList[key])
                }
            },

            navTo(item) {
                let newUrl = item.stored_path ? item.stored_path : item.url
                window.open(newUrl)
                // document.location.href = newUrl
            },
            // 获取目录
            async getProjectList(type) {
                await getDataItem({
                    data: {
                        type
                    },
                    success: res => {
                        // console.log('上传资料详情', res)
                        this.uploadData = res.data
                    }
                })
            },
            // 切换tab栏/
            changeTab(index) {
                this.navIndex = index
            },
            // 获取详情
            async getApplicationDetail() {
                await getApplicationDetail({
                    data: {
                        id: this.id
                    },
                    success: res => {
                        console.log('res', res)
                        this.project_code = res.data.project.project_code
                        this.project_app_num = res.data.basicMsg.project_application_id
                        this.pdbForm = res.data.basicMsg.pa_evaluate
                        // 对修改意见进行组织
                        if (res.data.modify_suggest) {
                            let changeList = []
                            let codeList = []
                            const dataList = res.data.modify_suggest
                            this.originList = res.data.modify_suggest
                            dataList.forEach((item) => {
                                let newlist = {}
                                newlist['feedback_time'] = item.feedback_time
                                if (item.suggest_content.length > 30) {
                                    newlist['suggest_content'] = item.suggest_content.slice(0,
                                        30) + '...'
                                } else {
                                    newlist['suggest_content'] = item.suggest_content
                                }
                                newlist['modify_status_text'] = item.modify_status_text
                                newlist['updated_at'] = item.updated_at
                                // 二级管理员 能查看
                                if (item.modify_status_text === '已修改') {
                                    newlist['soqcol'] = ['查看详情']
                                } else {
                                    newlist['soqcol'] = ['查看详情', '修改', '我已修改']
                                }
                                codeList.push(item.id)
                                changeList.push(newlist)
                            })
                            this.tableList = changeList
                            this.codeList = codeList
                        }

                        const uploadList = res.data.datas
                        let newUploadList = []
                        uploadList.forEach((item, index) => {
                            newUploadList[Number(item.type) - 1] = []
                        })
                        uploadList.forEach((item, index) => {
                            newUploadList[Number(item.type) - 1].push(item)
                        })
                        this.uploadList = newUploadList

                        // 工程信息
                        this.project = res.data.project
                        // 模板下载
                        this.modelList = JSON.parse(res.data.project.distribution_materials)

                        // 获奖信息
                        // this.award = res.data.award
                        this.award = res.data.basicMsg.pa_qualification
                        // 申报须知PDF
                        this.require_pdf_url = res.data.project.require_pdf_url
                        // 评选办法PDF
                        this.selection_pdf_url = res.data.project.selection_pdf_url

                        // 基本信息
                        let dataList = res.data.basicMsg
                        // 将基本信息加入到即将提交的列表中
                        Object.keys(dataList).forEach((item) => {
                            if (this.levelOne.hasOwnProperty(item)) {
                                this.levelOne[item] = dataList[item]
                            }
                        })

                        this.allList = dataList
                        // 优秀项目经理
                        if(this.project.project_type === '0'){
                            this.navList = [
                                "申报须知",
                                "评选办法",
                                "基本信息",
                                "个人简历",
                                "获奖信息",
                                "资料上传"
                            ]
                        }
                        // 优秀建造师
                        if (this.project.project_type === '1') {
                            delete this.formName.continue_edu_year
                            this.awardName = this.awardNameOne
                        }
                        // 优秀项目工程成果
                        if (this.project.project_type === '2') {
                            this.formName = this.newFormName
                            this.navList[3] = ''
                        }
                        // 优质安装工程
                        if (this.project.project_type === '5') {
                            this.formName = this.newFormNameThree
                            this.navList[3] = ''
                            this.navList[5] = '修改意见'
                        }
                        // 先进企业
                        if (this.project.project_type === '3') {
                            this.formName = this.newFormNameFour
                            this.awardName = this.awardNameTwo
                        }
                        // 质量小组
                        if (this.project.project_type === '6') {
                            this.formName = this.newFormNameSix
                        }

                        // 诚信企业
                        if (this.project.project_type === '4') {
                            this.formName = this.newFormNameEight
                        }

                        // BIM
                        if (this.project.project_type === '7') {
                            this.navList[3] = ''
                            this.formName = this.newFormNameSeven
                        }

                        this.getProjectList(this.project.project_type)

                        let newList = []
                        Object.keys(this.formName).forEach((item, index, array) => {
                            const newData = {}
                            newData.title = this.formName[item]
                            newData.data = dataList[item]
                            newList.push(newData)
                        })
                        // 额外处理建设单位显示
                        if (this.project.project_type === '5') {
                            const participating_units = JSON.parse(dataList.participating_units)
                            this.oldAddList = participating_units
                        }
                        // 处理BIM建设单位
                        if (this.project.project_type === '7') {
                            const outCode = newList[8]
                            newList.splice(8, 1)
                            const declarant_units = JSON.parse(dataList.declarant_units)
                            declarant_units.forEach((item, index) => {
                                const newData = {}
                                const newData2 = {}
                                newData.title = '企业类型'
                                newData.data = item.type
                                newData2.title = '单位名称'
                                newData2.data = item.name
                                newList.push(newData)
                                newList.push(newData2)
                            })
                            newList.push(outCode)
                        }
                        this.basicInfo = newList
                    }
                })
            },
            // 模板下载弹窗
            upShow(type, index) {
                this.clickIndex = index
                const params = {
                    type,
                    download: this.modelList
                }
                this.$refs['download'].showAdd(params)
            },
            //接受点击上传回穿
            submitSuccess(e) {
                if (this.uploadList[this.clickIndex]) {
                    let newList = JSON.parse(JSON.stringify(this.uploadList[this.clickIndex]))
                    e.forEach((item, index) => {
                        newList.push(item)
                    })
                    this.$set(this.uploadList, this.clickIndex, newList)
                    return
                }
                this.$set(this.uploadList, this.clickIndex, e)
            },
            // 内部评分弹窗
            showScore() {
                this.$refs['scoredialog'].showAdd('考核项目打分')
            }
        }
    }
</script>

<style scoped>
    /* 每个上传文件的样式 */
    .inner_upload {
        position: relative;
        min-height: 40px;
        margin: 0 10px;
        /* width: 100px; */
        /* overflow: scroll; */
    }

    .inner_upload p {
        color: #1890FF;
    }

    .inner_upload img {
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: 0;
        width: 15px;
        height: 15px;
        cursor: pointer;
    }

    .newTab {
        margin: 20px;
    }

    /* 上传样式 */
    .uploadBtn {
        margin-top: 60px;
        margin-bottom: 60px;
        display: flex;
        margin-left: 41.5%;
        /* margin-left: 695px; */
    }

    .uploadBtn button {
        width: 140px;
    }

    .uploadHead {
        display: flex;
        position: absolute;
        align-items: center;
        left: 255px;
    }

    .uploadHead p {
        margin-left: 10px;
        color: #1890FF;
        cursor: pointer;
    }

    .uploadList {
        border: 1px solid #f0f0f0;
        width: 90%;
        margin-top: 30px;
        margin-left: 5%;
    }

    .uploadList_head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 40px;
        padding: 0 40px 0 10px;
        line-height: 40px;
        font-size: 14px;
        flex-wrap: wrap;
        border-bottom: 1px solid #f0f0f0;
    }

    .uploadList_head p {
        text-align: left;
    }

    .head_list {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .head_list p {
        margin-left: 10px;
    }

    .head_list p:hover {
        color: #1890FF;
        text-decoration: underline;
    }

    .uploadList_mid {
        width: 90%;
        min-height: 30px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        justify-content: flex-start;
    }

    .uploadList_mid p {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        text-align: left;
        text-indent: 2em;
        padding: 10px;
    }

    .uploadList_bot {
        width: 70%;
        min-height: 30px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        justify-content: flex-start;
    }

    .uploadList_bot p {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        color: #1890FF;
        text-decoration: underline;
        margin: 0 20px;
        cursor: pointer;
    }

    /* 上传样式 */
    .uploadContent {
        padding-bottom: 60px;
    }

    .inputList {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .titleLeft {
        margin-left: 50px;
    }

    .view_head {
        font-size: 18px;
        font-weight: 600;
        margin-top: 20px;
    }

    .midflex {
        display: flex;
        width: 90%;
        height: 50px;
        margin-left: 5%;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #eee;
    }

    .newAddBtn {
        width: 100%;
        display: flex;
        height: 70px;
        align-items: center;
        justify-content: center;
    }

    .headView {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
    }

    .headView_top {
        width: 1350px;
        display: flex;
        justify-content: space-between;
    }

    .headView_top button {
        width: 100px;
        height: 35px;
        background-color: #1890FF;
        color: white;
        line-height: 35px;
        cursor: pointer;
    }

    .applyTitle {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #000000;
    }

    .headClass {
        display: flex;
        margin-top: 10px;
    }

    .headClass p {
        margin-right: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }

    /* 申报 */
    .content_view {
        margin-top: 20px;
        max-width: 1350px;
        min-height: 350px;
        display: flex;
        border: 1px solid #f0f0f0;
    }

    .contentLeft {
        width: 200px;
    }

    .contentLeft p {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #333333;
        background-color: #fafafa;
        cursor: pointer;
    }

    .contentRight {
        width: 100%;
    }

    .tabActive {
        background: #e6f7ff !important;
        color: #6ea7ff !important;
        border-right: 2px solid #0077ff;
    }

    .content_btn {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        margin-bottom: 30px;
    }

    .content_btn p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FE2C54;
    }

    .content_btn button {
        width: 150px;
        margin-top: 40px;
        margin-left: 440px;
    }

    .specialView {
        width: 720px;
        display: flex;
        align-items: center;
    }

    .specialView input {
        margin-left: 20px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        letter-spacing: 1px;
        border-bottom: 1px solid #DBDBDB;
    }

    .specialView input::placeholder {
        color: #B5B5B5;
    }

    /* gridtable */
    table.gridtable {
        font-family: verdana,arial,sans-serif;
        font-size:14px;
        color:#333333;
        border-width: 1px;
        border-color: #666666;
        border-collapse: collapse;
        margin: auto;
    }
    table.gridtable th {
        border-width: 1px;
        padding: 12px;
        border-style: solid;
        border-color: #666666;
        background-color: #dedede;
    }
    table.gridtable td {
        border-width: 1px;
        padding: 22px;
        border-style: solid;
        border-color: #666666;
        background-color: #ffffff;
    }

    table.gridtable .el-input__inner{
        border: none;
    }

    /* /gridtable */

</style>
